import { CSSProperties, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { PricingOnRequest, SvgIcon } from '@/components';
import { PlanCategoryEnum, tariffDisplayData } from '@/config';

import styles from './TariffsProDetails.module.sass';

const ACCENT_COLOR = tariffDisplayData[PlanCategoryEnum.PRO].color;

const FEATURE_ICONS = [
  'risk',
  'compliance-dashboard',
  'shield',
  'ban',
  'question-circle',
];

interface TariffsProDetailsProps {}

const TariffsProDetails: FC<TariffsProDetailsProps> = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: FEATURE_ICONS[0],
      title: t('translation.tariffs_pro_feature_risk_title'),
      text: t('translation.tariffs_pro_feature_risk_text'),
    },
    {
      icon: FEATURE_ICONS[1],
      title: t('translation.tariffs_pro_feature_sources_title'),
      text: t('translation.tariffs_pro_feature_sources_text'),
    },
    {
      icon: FEATURE_ICONS[2],
      title: t('translation.tariffs_pro_feature_sanctions_title'),
      text: t('translation.tariffs_pro_feature_sanctions_text'),
    },
    {
      icon: FEATURE_ICONS[3],
      title: t('translation.tariffs_pro_feature_ofac_title'),
      text: t('translation.tariffs_pro_feature_ofac_text'),
    },
    {
      icon: FEATURE_ICONS[4],
      title: t('translation.tariffs_pro_feature_support_title'),
      text: t('translation.tariffs_pro_feature_support_text'),
    },
  ];

  return (
    <div
      className={styles.details}
      style={{ '--pro-accent': ACCENT_COLOR } as CSSProperties}
    >
      <div className={styles.main}>
        <div className={styles.features}>
          {features.map((feature) => (
            <div key={feature.title} className={styles.feature}>
              <div className={styles.featureIcon}>
                <SvgIcon name={feature.icon} className={styles.featureSvg} />
              </div>
              <div className={styles.featureBody}>
                <div className={styles.featureTitle}>{feature.title}</div>
                <div className={styles.featureText}>{feature.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <PricingOnRequest color={ACCENT_COLOR} className={styles.pricing} />
    </div>
  );
};

export default TariffsProDetails;
